import { getSeoFiguresForLandingPath } from '../../lib/seoPageFiguresConfig'

/**
 * Responsive product figures for primary SEO pages (accessibility + CLS-friendly dimensions).
 * @param {{ logicalPath: string, className?: string }} props
 */
export function SeoPageFigures({ logicalPath, className = '' }) {
  const figures = getSeoFiguresForLandingPath(logicalPath)
  if (!figures?.length) return null

  const gridClass =
    figures.length >= 3
      ? 'seo-page-figures--cols-3'
      : figures.length === 2
        ? 'seo-page-figures--cols-2'
        : 'seo-page-figures--cols-1'

  return (
    <div className={`seo-page-figures ${gridClass} ${className}`.trim()} role="group" aria-label="Product screenshots">
      {figures.map((fig, idx) => {
        const isPrimary = idx === 0
        const loading = idx === 0 ? (fig.eager ? 'eager' : 'lazy') : 'lazy'
        const fetchPriority = isPrimary && fig.eager ? 'high' : 'low'
        return (
          <figure
            key={fig.src}
            className={`seo-page-figures__figure${isPrimary ? ' seo-page-figures__figure--primary' : ''}`}
          >
            <img
              className={`seo-page-figures__img${isPrimary ? ' seo-page-figures__img--hero' : ''}`}
              src={fig.src}
              alt={fig.alt}
              width={fig.width}
              height={fig.height}
              sizes="(max-width: 1200px) 100vw, 1200px"
              loading={loading}
              decoding="async"
              fetchPriority={fetchPriority}
            />
            {fig.caption ? <figcaption className="seo-page-figures__caption">{fig.caption}</figcaption> : null}
          </figure>
        )
      })}
    </div>
  )
}
